export const debug = 0;
export const warn = 5;
export const error = 10;